import {Injectable} from '@angular/core';
import {IRecuperationListeDonneesMetier} from '@app/core/interfaces';
import {Observable} from 'rxjs';
import {Autowired} from '@angular-ru/autowired';
import {MotifRejetTableListeRestApiService} from './motif-rejet-table.liste.rest-api.service';

@Injectable({providedIn: 'root'})
export class MotifRejetTableListeMetierService implements IRecuperationListeDonneesMetier {
  @Autowired() restApi: MotifRejetTableListeRestApiService;

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    return this.restApi.requeteRecuperationListeDonnees(data, args);
  }
}
